import { Action, Reducer } from 'redux';
import { DEFAULT_THEME_MODE, ThemeMode, isThemeMode } from '../../theme/guideTokens';
import { SET_BLUE_LIGHT, SET_BLUE_LIGHT_LEVEL, SET_THEME_MODE, ThemeKnownAction } from '../actions/Theme.Actions';
import { DEFAULT_BLUE_LIGHT_LEVEL, clampBlueLightLevel } from '../../theme/blueLight';

export interface ThemeState {
  mode: ThemeMode;
  /** Reducción de luz azul (filtro cálido) sobre cualquier modo. */
  blueLight: boolean;
  /** Intensidad del filtro en porcentaje (10..100). */
  blueLightLevel: number;
  userId?: string;
}

export const ThemeUnloadedState: ThemeState = {
  mode: DEFAULT_THEME_MODE,
  blueLight: false,
  blueLightLevel: DEFAULT_BLUE_LIGHT_LEVEL,
  userId: undefined,
};

export const ThemeReducer: Reducer<ThemeState> = (
  state: ThemeState | undefined,
  incomingAction: Action
): ThemeState => {
  if (state === undefined) return ThemeUnloadedState;
  const action = incomingAction as ThemeKnownAction;
  switch (action.type) {
    case SET_THEME_MODE:
      if (!isThemeMode(action.mode)) return state;
      return { ...state, mode: action.mode, userId: action.userId };
    case SET_BLUE_LIGHT:
      return { ...state, blueLight: !!action.enabled, userId: action.userId ?? state.userId };
    case SET_BLUE_LIGHT_LEVEL:
      return { ...state, blueLightLevel: clampBlueLightLevel(action.level), userId: action.userId ?? state.userId };
    default:
      return state;
  }
};
